import type SimpleBarClass from "simplebar";

import { IS_ACTIVE, MENU_DURATION } from "../_defs";
import { disableScroll } from "../functions/_disableScroll";
import { enableScroll } from "../functions/_enableScroll";

import { mobileQuery } from "./_mobileQuery";

const IS_MENU_SHOWN = "is-menu-shown";

const PC_PARAMETERS = {
  before: { x: "-20%", y: 0, opacity: 0 },
  after: { x: 0, y: 0, opacity: 1 }
};
const SP_PARAMETERS = {
  before: { x: 0, y: "20%", opacity: 0 },
  after: { x: 0, y: 0, opacity: 1 }
};

const IS_ACTIVATE = "is-activate";
const IS_DEACTIVATE = "is-deactivate";

export const setupMenu = (): void => {
  const button = document.getElementById("menuButton");
  const menu = document.getElementById("menu");
  const menuInner = document.getElementById("menuInner");
  const html = document.documentElement;

  if (!button || !menu || !menuInner) return;

  let shown = false;
  let busy = false;
  let scrollBar: SimpleBarClass | undefined;

  const adjustScrollbar = (): void => {
    if (mobileQuery.matches) {
      if (scrollBar) {
        scrollBar.recalculate();
      } else {
        scrollBar = new SimpleBar(menuInner, { autoHide: false });
      }
    } else {
      if (scrollBar) {
        scrollBar.unMount();
      }
      scrollBar = undefined;
    }
  };

  const show = (): void => {
    if (busy || shown) return;
    busy = true;
    html.classList.add(IS_MENU_SHOWN);

    button.classList.add(IS_ACTIVATE);

    const parameters = mobileQuery.matches ? SP_PARAMETERS : PC_PARAMETERS;

    gsap.fromTo(
      menu,
      {
        display: "flex",
        ...parameters.before
      },
      {
        duration: MENU_DURATION,
        ...parameters.after,
        onStart() {
          adjustScrollbar();
          disableScroll(menuInner);
        },
        onComplete() {
          shown = true;
          busy = false;
          button.classList.add(IS_ACTIVE);
          button.classList.remove(IS_ACTIVATE);
        }
      }
    );
  };

  const hide = (): void => {
    if (busy || !shown) return;
    busy = true;

    const parameters = mobileQuery.matches ? SP_PARAMETERS : PC_PARAMETERS;

    button.classList.add(IS_DEACTIVATE);

    gsap.fromTo(
      menu,
      {
        display: "flex",
        ...parameters.after
      },
      {
        duration: MENU_DURATION,
        ...parameters.before,
        display: "none",
        onComplete() {
          shown = false;
          busy = false;
          html.classList.remove(IS_MENU_SHOWN);

          button.classList.remove(IS_DEACTIVATE);
          button.classList.remove(IS_ACTIVE);

          enableScroll(menuInner);
        }
      }
    );
  };

  button.addEventListener("click", () => {
    if (shown) {
      hide();
    } else {
      show();
    }
  });

  // メニュー内にあるリンクがアンカーリンクだった場合、メニューを閉じる
  menu.querySelectorAll<HTMLAnchorElement>("a").forEach((a) => {
    if (a.pathname === window.location.pathname) {
      a.addEventListener("click", () => {
        hide();
      });
    }
  });
};
